export default __webpack_public_path__ + "74401f00ca6b6eed478672cb6c294725.png";